/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter, useParams, useHistory } from "react-router-dom";
import Page from "components/common_components/Page/Page";
import { useDispatch, useSelector } from "react-redux";
import { notifyError, notifySuccess } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import Form from "./Form";
import SettingsContext from "../SettingsContext";
import { updateUser } from "redux/actions/Login";
import Header from "components/common_components/Header";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import { Grid } from "@material-ui/core";
import { buildUserState } from "components/Login/utils";

function User(props) {
    const history = useHistory();
    const { id } = useParams();
    const [user, setUser] = useState(undefined);
    const [resources, setResources] = useState({ modules: [], groups: [] });
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const { user: loggedInUser } = useSelector((state) => state.Login);
    const { mode } = props;

    const { Users, Modules, Groups } = useContext(SettingsContext);

    function getUser() {
        setIsLoading(true);
        Users.getOneById({
            id,
            onSuccess: (data) => {
                setUser(data);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    function getModules() {
        setIsLoading(true);
        Modules.getAll({
            onSuccess: (data) => {
                setResources((prev) => ({
                    ...prev,
                    modules: data,
                }));
                setIsLoading(false);
            },
            onError: (error) => {
                setResources((prev) => ({
                    ...prev,
                    modules: [],
                }));
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    function getGroups() {
        setIsLoading(true);
        Groups.getAll({
            onSuccess: (data) => {
                setResources((prev) => ({
                    ...prev,
                    groups: data,
                }));
                setIsLoading(false);
            },
            onError: (error) => {
                setResources((prev) => ({
                    ...prev,
                    groups: [],
                }));
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    useEffect(() => {
        if (id) {
            getUser();
        }
    }, [id]);

    useEffect(() => {
        getModules();
        getGroups();
    }, []);

    function onEditHandler() {
        history.push(`/settings/users/${id}/update`);
    }

    function onCancelHandler() {
        history.push(`/settings/users`);
    }

    async function onSuccess(sentPayload, setSubmitting) {
        dispatch(notifySuccess(`User ${mode === "add" ? "created" : "updated"} successfully!`));

        if (mode === "add") {
            Users.signUpUser({
                email: sentPayload.email,
                password: sentPayload.password,
                onSuccess: () => {
                    dispatch(notifySuccess("User authorized successfully!"));
                    onCancelHandler();
                    setSubmitting(false);
                },
                onError: (error) => dispatch(notifyError(error)),
            });
        } else {
            onCancelHandler();
            setSubmitting(false);
            if (Number(loggedInUser.id) === Number(id)) {
                try {
                    const refreshedUser = await Users.getOneByIdAsync(id);
                    const userState = buildUserState(refreshedUser);
                    dispatch(updateUser(userState));
                } catch (error) {}
            }
        }
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            onCancelHandler();
            dispatch(notifyError(error));
        }
        setSubmitting(false);
    }

    function onSubmitHandler(values, { setSubmitting, setErrors }) {
        const { email, password, modules, ...payload } = values;

        const moduleIds = Object.keys(modules).filter((x) => modules[x]);

        const apiCall = mode === "add" ? Users.add : Users.update;

        const payloadToSend = {
            id: mode === "update" ? id : null,
            ...payload,
            password,
            email: email.trim().toLowerCase(),
            moduleIds,
            isAuthorized: true,
        };

        setSubmitting(true);

        apiCall({
            payload: payloadToSend,
            onSuccess: () => onSuccess(payloadToSend, setSubmitting),
            onError: (error) => onError(error, setSubmitting, setErrors),
        });
    }

    return (
        <Page className="settings-users-page">
            <Grid container spacing={3} justifyContent="center">
                <Grid item sm={12} md={12} lg={10}>
                    <Header title={(user && user.name) || "New user"}>
                        {mode !== "add" && (
                            <div
                                style={{
                                    margin: 0,
                                    backgroundColor: "green",
                                    color: "white",
                                    display: "flex",
                                    alignItems: "center",
                                    padding: 5,
                                    borderRadius: 5,
                                }}
                            >
                                <VerifiedUserIcon />
                                <span>Authorized</span>
                            </div>
                        )}
                    </Header>
                </Grid>
            </Grid>

            {isLoading && <LoadingPage />}
            {!isLoading && ((mode !== "add" && user) || mode === "add") && (
                <Form
                    data={user}
                    resources={resources}
                    {...props}
                    onCancel={onCancelHandler}
                    onSubmit={onSubmitHandler}
                    onEdit={onEditHandler}
                />
            )}
        </Page>
    );
}

User.propTypes = {
    mode: PropTypes.oneOf(["add", "detail", "update"]).isRequired,
    title: PropTypes.string,
};

export default withRouter(User);
